export function getVMapPolygons(payload) {
    return Array.isArray(payload?.polygons) ? payload.polygons : [];
}

export function getVMapPolygonEntry(payload, { strategy = 'first' } = {}) {
    const polygons = getVMapPolygons(payload);

    if (!polygons.length) {
        return null;
    }

    return strategy === 'last' ? polygons[polygons.length - 1] : polygons[0];
}

export function getVMapPolygonData(entry) {
    if (!entry) {
        return null;
    }

    const raw = entry.data ?? entry;
    return raw?.polygons ?? raw ?? null;
}

export function getVMapClickedPolygonData(payload, options = {}) {
    return getVMapPolygonData(getVMapPolygonEntry(payload, options));
}
